import { ApiKey, ApiKeyRole, CreatedApiKey } from "../../../models";

export const getApiKey = (data: any): ApiKey => ({
  id: data.id,
  name: data.name,
  keyPrefix: data.key_prefix,
  role: data.role as ApiKeyRole,
  createdAt: data.created_at,
  lastUsedAt: data.last_used_at ?? undefined,
  revokedAt: data.revoked_at ?? undefined,
});

export const getApiKeys = (data: any): ApiKey[] => (data ?? []).map(getApiKey);

export const getCreatedApiKey = (data: any): CreatedApiKey => ({
  id: data.id,
  name: data.name,
  keyPrefix: data.key_prefix,
  role: data.role as ApiKeyRole,
  key: data.key,
});
